import lodash from "lodash";
import store from '../store';
import axios from "axios";
import moment from 'moment';

const helpFunctions = {
    modal_functions: {
        openModal(ref) {
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
    },
    tags: [],
    documents: [],
    reg_exp: "",
    found_models: [],
    found_model_ids: [],
    model_ids_for_search: [],
    headers: {
        job_queue: [
            { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
            { title: store.getters.translate('name'), align: "start", sortable: true, value: 'name' },
            { title: store.getters.translate('date'), align: "start", sortable: true, value: 'date' }
        ],
        attributes: [
            { title: '', align: "start", fixed: true, sortable: false, value: "Draggable" },
            { title: store.getters.translate('name'), align: "start", fixed: true, sortable: false, value: 'name' },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
        introductions: [
            { title: '', align: "start", fixed: true, sortable: false, value: "Draggable" },
            { title: store.getters.translate('sort_order'), align: "start", fixed: true, sortable: false, value: "sort_order" },
            { title: store.getters.translate('page'), align: "start", fixed: true, sortable: false, value: 'page' },
            { title: store.getters.translate('title'), align: "start", fixed: true, sortable: false, value: 'title' },
            { title: store.getters.translate('placement'), align: "start", fixed: true, sortable: false, value: 'placement' },
            { title: store.getters.translate('introduction_active'), align: "start", fixed: true, sortable: false, value: 'introduction_active' },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
        procedure_results: [
            { title: '', align: "start", fixed: true, sortable: false, value: "Draggable" },
            { title: store.getters.translate('sort_order'), align: "start", fixed: true, sortable: false, value: "sort_order" },
            { title: store.getters.translate('name'), align: "start", fixed: true, sortable: false, value: 'name' },
            { title: store.getters.translate('description'), align: "start", fixed: true, sortable: false, value: 'description' },
            { title: store.getters.translate('result'), align: "start", fixed: true, sortable: false, value: 'result' },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
        project_management_questions_and_answers: [
            { title: '', align: "start", fixed: true, sortable: false, value: "Draggable" },
            { title: store.getters.translate('sort_order'), align: "start", fixed: true, sortable: false, value: "sort_order" },
            { title: store.getters.translate('name'), align: "start", fixed: true, sortable: false, value: "name" },
            { title: store.getters.translate('category'), align: "start", fixed: true, sortable: false, value: "category" },
            { title: store.getters.translate('subcategory'), align: "start", fixed: true, sortable: false, value: "subcategory" },
            { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
        ],
        found_or_broken_phases: [
            {title: '', key: 'data-table-group'},
            { title: store.getters.translate("wo_number"), align: "start", sortable: true, value: "wo_number", width: "10%" },
            { title: store.getters.translate("name"), align: "start", sortable: true, value: "name", width: "20%" },
            { title: store.getters.translate("type"), align: "start", sortable: true, value: "type", width: "10%" },
            { title: store.getters.translate("start_date"), align: "start", sortable: true, value: "start_date", width: "10%" },
            { title: store.getters.translate("complete_date"), align: "start", sortable: true, value: "complete_date", width: "10%" },
            { title: store.getters.translate("shutdown_required"), align: "start", sortable: true, value: "shutdown_required", width: "10%" },
            { title: store.getters.translate("shutdown_required_start_date"), align: "start", sortable: true, value: "shutdown_required_start_date", width: "10%" },
            { title: store.getters.translate("shutdown_required_complete_date"), align: "start", sortable: true, value: "shutdown_required_complete_date", width: "10%" },
            { title: "Status", align: "start", sortable: true, value: "status_text", width: "10%" }
        ],
        not_found_phases: [
            {title: '', key: 'data-table-group'},
            { title: store.getters.translate("wo_number"), align: "start", sortable: true, value: "wo_number", width: "10%" },
            { title: store.getters.translate("name"), align: "start", sortable: true, value: "phase_name", width: "20%" },
            { title: store.getters.translate("type"), align: "start", sortable: true, value: "phase_type", width: "10%" },
            { title: store.getters.translate("start_date"), align: "start", sortable: true, value: "phase_start_date", width: "10%" },
            { title: store.getters.translate("complete_date"), align: "start", sortable: true, value: "phase_complete_date", width: "10%" },
        ],
        flatfile_history: [
            { title: store.getters.translate('name'), align: "start", sortable: true, value: 'name' },
            { title: store.getters.translate('size'), align: "start", sortable: true, value: 'size' },
            { title: store.getters.translate('date'), align: "start", sortable: true, value: 'createdAt' },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
        import_cable_assets: [
            { title: '', key: 'data-table-group' },
            { title: "Cable nr", key: "cable_nr", value: "cable_nr" },
            { title: "From", key: "from", value: "from" },
            { title: "To", key: "to", value: "to" },
            { title: "Forms linked to equipment type", key: "equipment_type", value: "equipment_type" }
        ],
        import_other_assets: [
            { title: '', key: 'data-table-group' },
            { title: "Tag nr", key: "tag_nr", value: "tag_nr" },
            { title: "Forms linked to equipment type", key: "equipment_type", value: "equipment_type" },
            { title: "Import property", key: "import_property", value: "import_property" }
        ],
        cuurios_planning: [
            { title: store.getters.translate('name'), align: "start", sortable: true, value: 'name', width: "35%" },
            { title: store.getters.translate('start_date'), align: "start", sortable: true, value: 'start_date' },
            { title: store.getters.translate('complete_date'), align: "start", sortable: true, value: 'complete_date' },
            { title: store.getters.translate('days'), align: "start", sortable: true, value: 'days' },
            { title: store.getters.translate('pax'), align: "start", sortable: true, value: 'pax' },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
        defects: [
            { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
            { title: store.getters.translate('defect_status'), align: "center", sortable: true, value: 'status', width: '100px' },
            { title: store.getters.translate('priority'), align: "start", sortable: true, value: 'priority' },
            { title: store.getters.translate('section'), align: "start", sortable: true, value: 'distribution_device_function_name' },
            { title: store.getters.translate('deficiency_group'), align: "start", sortable: true, value: 'deficiency_group' },
            { title: store.getters.translate('distribution_panel_name'), align: "start", sortable: true, value: 'distribution_panel_name' },
            { title: store.getters.translate('circuit_number'), align: "start", sortable: true, value: 'circuit_number' },
            { title: store.getters.translate('tag_number_name'), align: "start", sortable: true, value: 'tag_number_name' },
            { title: store.getters.translate('description'), align: "start", sortable: true, value: 'description' },
            { title: store.getters.translate('location_name'), align: "start", sortable: true, value: 'location_name' },
            { title: store.getters.translate('drawing_number'), align: "start", sortable: true, value: 'drawing_number' },
            { title: store.getters.translate('revision'), align: "start", sortable: true, value: 'revision' },
            { title: store.getters.translate('defect_description'), align: "start", sortable: true, value: 'defect_description' },
            { title: store.getters.translate('remarks'), align: "start", sortable: true, value: 'remarks' },
            { title: store.getters.translate('root_asset_name'), align: "start", sortable: true, value: 'root_asset_name' },
            { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
        ],
        measurements: [
            { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
            { title: store.getters.translate('section'), align: "start", sortable: true, value: 'distribution_device_function_name' },
            { title: store.getters.translate('distribution_panel_name'), align: "start", sortable: true, value: 'distribution_panel_name' },
            { title: store.getters.translate('circuit_number'), align: "start", sortable: true, value: 'circuit_number' },
            { title: store.getters.translate('tag_number_name'), align: "start", sortable: true, value: 'tag_number_name' },
            { title: store.getters.translate('description'), align: "start", sortable: true, value: 'description' },
            { title: store.getters.translate('location_name'), align: "start", sortable: true, value: 'location_name' },
            { title: store.getters.translate('root_asset_name'), align: "start", sortable: true, value: 'root_asset_name' },
            { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
        ],
        inspections: [
            { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
            { title: store.getters.translate('wo_number'), align: "start", sortable: true, value: 'wo_number' },
            { title: store.getters.translate('date'), align: "start", sortable: true, value: 'inspection_period' },
            { title: store.getters.translate('root_asset_name'), align: "start", sortable: true, value: 'root_asset_name' },
            { title: store.getters.translate('project_number'), align: "start", sortable: true, value: 'project_number' },
            { title: store.getters.translate('description'), align: "start", sortable: true, value: 'description' },
            { title: store.getters.translate('defects'), align: "center", sortable: true, value: 'defects', width: '150px' },
            { title: store.getters.translate('progress'), align: "center", sortable: true, value: 'progress', width: '120px' },
            { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
        ],
        articles: [
            { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
            { title: store.getters.translate('tag_number_name'), align: "start", sortable: true, value: 'tag_number_name' },
            { title: store.getters.translate('serial_number'), align: "start", sortable: true, value: 'serial_number' },
            { title: store.getters.translate('type'), align: "start", sortable: true, value: 'type' },
            { title: store.getters.translate('brand_name'), align: "start", sortable: true, value: 'brand_name' },
            { title: store.getters.translate('root_asset_name'), align: "start", sortable: true, value: 'root_asset_name' },
            { title: store.getters.translate('location_name'), align: "start", sortable: true, value: 'location_name' },
            { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
        ],
        reassigned_items: [
            { title: store.getters.translate("user_name"), align: "start", sortable: true, value: "user.name" },
            { title: store.getters.translate("delegate_name"), align: "start", sortable: true, value: "delegate.name" },
            { title: store.getters.translate("reassign_date"), align: "start", sortable: true, value: "reassign_date" },
            { title: store.getters.translate("reassign_till"), align: "start", sortable: true, value: "reassign_till" },
            { title: '', align: 'center', fixed: true, sortable: false, value: 'actions', width: '80px' }
        ],
    },
    footer_props: {
        itemsPerPageOptions: [
            {value:15, title:'15'},
            {value:25, title:'25'},
            {value:50, title:'50'},
            {value:75, title:'75'},
            {value:100, title:'100'},
            {value:125, title:'125'},
            {value:150, title:'150'},
            {value:175, title:'175'},
            {value:200, title:'200'},
            {value:250, title:'250'},
            {value:300, title:'300'}
        ],
        itemsPerPageText: "Rows per page:",
    },
    table_options: {
        itemsPerPage: 15,
        page: 1,
        sortBy: [{"key": "id", "order": "asc"}],
        hide_closed_projects: true,
        hide_closed_punchlists: true,
        hide_closed_action_and_decisions: true,
        hide_closed_projectmanagement: true,
        hide_closed_dnvverificationregisters: true,
        hide_closed_defects: true
    },
    margins: {
        margin_top: 10,
        margin_bottom: 10,
        margin_left: 10,
        margin_right: 10,
    },
    field_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
        { value: "read_only", text: store.getters.translate("read_only") },
        { value: "link", text: store.getters.translate("link") },
    ],
    question_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
    ],
    can_search: {
        project: 'projects',
        punchlist: 'punchlists',
        projectmanagement: 'projectmanagement',
        asset: 'assets',
        document: 'documents',
    },
    inspections_related_models: {
        ambienttemperature: 'ambienttemperatures',
        application: 'applications',
        brand: 'brands',
        classification: 'classifications',
        climate: 'climate',
        conformitymark: 'conformitymarks',
        distributionpanel: 'distributionpanels',
        distributiondevicefunction: 'distributiondevicefunctions',
        emergency: 'emergencies',
        equipmentcategory: 'equipmentcategories',
        equipmentgroup: 'equipmentgroups',
        equipmentprotectionlevel: 'equipmentprotectionlevels',
        equipmenttype: 'equipmenttypes',
        explosiveatmosphere: 'explosiveatmospheres',
        gasgroup: 'gasgroups',
        impactload: 'impactloads',
        inspectioncode: 'inspectioncodes',
        inspectioninstitute: 'inspectioninstitutes',
        inspectioninstitutecertification: 'inspectioninstitutecertifications',
        ipindication: 'ipindications',
        iptype: 'iptypes',
        linevoltage: 'linevoltage',
        location: 'locations',
        markering: 'markering',
        material: 'materials',
        powersystem: 'powersystems',
        protectionkind: 'protectionkinds',
        protectionmethod: 'protectionmethods',
        protectiontype: 'protectiontypes',
        regulation: 'regulations',
        room: 'rooms',
        stof: 'stof',
        substance: 'substances',
        temperatureclass: 'temperatureclasses',
        vibration: 'vibrations',
        water: 'water',
    },
    pages: {
        actions: { name: "actions", model: "action" },
        actionanddecisions: { name: "actionanddecisions", model: "actionanddecision" },
        actionanddecisionitems: { name: "actionanddecisionitems", model: "actionanddecisionitem" },
        articles: { name: "articles", model: "article" },
        ambienttemperatures: { name: "ambienttemperatures", model: "ambienttemperature" },
        applications: { name: "applications", model: "application" },
        assets: { name: "assets", model: "asset" },
        brands: { name: "brands", model: "brand" },
        characteristics: { name: "characteristics", model: "characteristic" },
        classifications: { name: "classifications", model: "classification" },
        climate: { name: "climate", model: "climate" },
        companies: { name: "companies", model: "company" },
        conformitymarks: { name: "conformitymarks", model: "conformitymark" },
        contacts: { name: "contacts", model: "contact" },
        custompermissions: { name: "custompermissions", model: "custompermission" },
        cuuriosplanning: { name: "cuuriosplanning", model: "cuuriosplanning" },
        damagechances: { name: "damagechances", model: "damagechance" },
        dashboard: { name: "dashboard", model: "dashboard" },
        documents: { name: "documents", model: "document" },
        documentation: { name: "documentation", model: "documentation" },
        defects: { name: "defects", model: "defect" },
        distributionpanels: { name: "distributionpanels", model: "distributionpanel" },
        distributiondevicefunctions: { name: "distributiondevicefunctions", model: "distributiondevicefunction" },
        dnvverificationregisters: { name: "dnvverificationregisters", model: "dnvverificationregister" },
        emergencies: { name: "emergencies", model: "emergency" },
        employees: { name: "employees", model: "employee" },
        environments: { name: "environments", model: "environment" },
        equipmentcategories: { name: "equipmentcategories", model: "equipmentcategory" },
        equipmentgroups: { name: "equipmentgroups", model: "equipmentgroup" },
        equipmentprotectionlevels: { name: "equipmentprotectionlevels", model: "equipmentprotectionlevel" },
        equipmenttypes: { name: "equipmenttypes", model: "equipmenttype" },
        explosiveatmospheres: { name: "explosiveatmospheres", model: "explosiveatmosphere" },
        externallinks: { name: "externallinks", model: "externallink" },
        expertises: { name: "expertises", model: "expertise" },
        fields: { name: "fields", model: "field" },
        fieldsets: { name: "fieldsets", model: "fieldset" },
        forms: { name: "forms", model: "form" },
        formquestions: { name: "formquestions", model: "formquestion" },
        gasgroups: { name: "gasgroups", model: "gasgroup" },
        home: { name: "home", model: "home" },
        impactloads: { name: "impactloads", model: "impactload" },
        importassets: { name: "importassets", model: "importasset" },
        importdefects: { name: "importdefects", model: "importdefect" },
        importinspections: { name: "importinspections", model: "importinspection" },
        importmeasurements: { name: "importmeasurements", model: "importmeasurement" },
        importphases: { name: "importphases", model: "importphase" },
        inspections: { name: "inspections", model: "inspection" },
        inspectioncertificates: { name: "inspectioncertificates", model: "inspectioncertificate" },
        inspectionclasses: { name: "inspectionclasses", model: "inspectionclass" },
        inspectioncodes: { name: "inspectioncodes", model: "inspectioncode" },
        inspectioninstitutecertifications: { name: "inspectioninstitutecertifications", model: "inspectioninstitutecertification" },
        inspectioninstitutes: { name: "inspectioninstitutes", model: "inspectioninstitute" },
        inspectiondelays: { name: "inspectiondelays", model: "inspectiondelay" },
        intensity: { name: "intensity", model: "intensity" },
        introductions: { name: "introductions", model: "introduction" },
        ipindications: { name: "ipindications", model: "ipindication" },
        iptypes: { name: "iptypes", model: "iptype" },
        linevoltage: { name: "linevoltage", model: "linevoltage" },
        locations: { name: "locations", model: "location" },
        markering: { name: "markering", model: "markering" },
        materials: { name: "materials", model: "material" },
        meetings: { name: "meetings", model: "meeting" },
        measurements: { name: "measurements", model: "measurement" },
        modellogs: { name: "modellogs", model: "modellog" },
        notes: { name: "notes", model: "note" },
        notifications: { name: "notifications", model: "notification" },
        people: { name: "people", model: "people" },
        planner: { name: "planner", model: "planner" },
        platformmanagement: { name: "platformmanagement", model: "platformmanagement" },
        powersystems: { name: "powersystems", model: "powersystem" },
        phases: { name: "phases", model: "phase" },
        projects: { name: "projects", model: "project" },
        projectmanagement: { name: "projectmanagement", model: "projectmanagement" },
        projectmanagementlogs: { name: "projectmanagementlogs", model: "projectmanagementlog" },
        projectmanagementquestions: { name: "projectmanagementquestions", model: "projectmanagementquestion" },
        projectmanagementtasks: { name: "projectmanagementtasks", model: "projectmanagementtask" },
        projectmanagementanswers: { name: "projectmanagementanswers", model: "projectmanagementanswer" },
        protectionkinds: { name: "protectionkinds", model: "protectionkind" },
        protectionmethods: { name: "protectionmethods", model: "protectionmethod" },
        protections: { name: "protections", model: "protection" },
        protectiontypes: { name: "protectiontypes", model: "protectiontype" },
        profile: { name: "profile", model: "employee" },
        punchlistitems: { name: "punchlistitems", model: "punchlistitem" },
        punchlists: { name: "punchlists", model: "punchlist" },
        procedures: { name: "procedures", model: "procedure" },
        proceduresteps: { name: "proceduresteps", model: "procedurestep" },
        questionnaires: { name: "questionnaires", model: "questionnaire" },
        questioncategories: { name: "questioncategories", model: "questioncategory" },
        questionnairequestions: { name: "questionnairequestions", model: "questionnairequestion" },
        reassigneditems: { name: "reassigneditems", model: "reassigneditem" },
        regulations: { name: "regulations", model: "regulation" },
        reports: { name: "reports", model: "report" },
        roles: { name: "roles", model:"role" },
        rooms: { name: "rooms", model:"room" },
        search: { name: "search", model: "search" },
        inspectionsconfig: { name: "inspectionsconfig", model: "inspectionsconfig" },
        settings: { name: "settings", model: "setting" },
        stof: { name: "stof", model: "stof" },
        substances: { name: "substances", model: "substance" },
        tags: { name: "tags", model: "tag" },
        tagnumbers: { name: "tagnumbers", model: "tagnumber" },
        temperatureclasses: { name: "temperatureclasses", model: "temperatureclass" },
        templates: { name: "templates", model: "template" },
        tokens: { name: "tokens", model: "token" },
        translations: { name: "translations", model: "translation" },
        triggers: { name: "triggers", model: "trigger" },
        typesandsubtypes: { name: "typesandsubtypes", model: "typesandsubtype" },
        todolists: { name: "todolists", model: "todolist" },
        usagefrequency: { name: "usagefrequency", model: "usagefrequency" },
        vibrations: { name: "vibrations", model: "vibration" },
        water: { name: "water", model: "water" },
        workequipmentgroups: { name: "workequipmentgroups", model: "workequipmentgroup" },
        workflows: { name: "workflows", model: "workflow" },
    },
    base_table_includable_options: {
        articles: {},
        actionanddecisions: {
            actionanddecisionitems: {
                create: true,
            },
        },
        companies: {
            employees: {
                create: true,
                link: true,
                detachable: true,
            },
            contacts: {
                create: true,
                link: true,
                detachable: true,
            },
            projectmanagement: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        contacts: {
            companies: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        employees: {
            expertises: {
                create: true,
                link: true,
                detachable: true,
            },
            procedures: {},
            roles: {
                link: true,
                detachable: true,
            },
            tokens: {
                create: true,
            },
            companies: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
            }
        },
        equipmenttypes: {
            forms: {
                create: true,
                link: true,
                detachable: true,
            },
        },
        inspections: {
            measurements: {
                no_select: true,
            },
        },
        inspectioncertificates: {
            articles: {
                no_select: true,
            },
        },
        projects: {
            documents: {},
        },
        projectmanagement: {
            projectmanagementtasks: {
                create: true,
            },
            companies: {
                link: true,
                detachable: true,
            },
        },
        punchlists: {
            punchlistitems: {
                create: true,
            },
        },
        questionnaires: {
            forms: {
                create: true,
                link: true,
                detachable: true,
            },
        },
        search: {
            projects: {
                no_select: true,
            },
            punchlists: {
                no_select: true,
            },
            projectmanagement: {
                no_select: true,
            },
            assets: {
                no_select: true,
            },
            documents: {
                no_select: true,
            },
        },
        tagnumbers: {
            articles: {
                no_select: true,
            },
        },
        workflows: {
            actions: {
                create: true,
            },
            triggers: {
                create: true,
            },
        },
    },
    //PROJECT MANAGEMENT ANSWER FUNCTIONS
    getProjectManagementAnswerCategories() {
        return ["Project Engineer", "Construction", "Commissioning", "QA/QC"];
    },
    getProjectManagementAnswerSubcategories() {
        let subcategories = [];
        subcategories["Project Engineer"] = ["Initiate phase (CP0+CP1)", "Define phase (CP2+CP3)", "Detailed design (CP4)", "Construct (CP5)", "Commissioning (CP6)", "Close out (CP7)"];
        subcategories["Construction"] = ["Pre-execution phase", "Execution phase", "Post-Execution phase"];
        subcategories["Commissioning"] = ["Pre-execution phase", "Execution phase", "Post-Execution phase"];
        subcategories["QA/QC"] = ["Pre-execution phase", "Execution phase", "Post-Execution phase"];
        return subcategories;
    },
    //TABLES FUNCTIONS
    showRecords(all_records, response_fields, advanced_search, page_name) {
        let sorted_array = all_records;
        let field_names = Object.keys(response_fields);
        for (let i = 0; i < field_names.length; i++) {
            if(field_names[i] === 'tags') {
                sorted_array = advanced_search['tags'].length > 0 ? this.sortByTagsBase(sorted_array, advanced_search['tags']) : sorted_array;
            }
            else if (advanced_search[field_names[i]] !== undefined && advanced_search[field_names[i]] !== null && advanced_search[field_names[i]] !== "") {
                if(response_fields[field_names[i]] === 'boolean' && page_name !== 'punchlistitems') {
                    sorted_array = sorted_array.filter(item => (item[field_names[i]] && advanced_search[field_names[i]]) || (!item[field_names[i]] && !advanced_search[field_names[i]]));
                }
                else {
                    sorted_array = sorted_array.filter(item => item[field_names[i]] && item[field_names[i]] !== "" && item[field_names[i]].toLowerCase().includes(advanced_search[field_names[i]].toLowerCase()));
                }
            }
            if(sorted_array.length === 0) {
                break;
            }
        }
        return sorted_array;
    },
    sortByTagsBase(sorted_array, tags) {
        let response = [];
        for (let i = 0; i < sorted_array.length; i++) {
            if (sorted_array[i].tags.length > 0) {
                let found = false;
                for (let x = 0; x < sorted_array[i].tags.length; x++) {
                    for (let y = 0; y < tags.length; y++) {
                        if (sorted_array[i].tags[x] == tags[y]) {
                            response.push(sorted_array[i]);
                            found = true;
                            break;
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
        }
        return response;
    },
    //ASSETS FUNCTIONS
    searchAssetByID(assets, asset_ids) {
        let found_assets = [];
        asset_ids.forEach((asset_id) => {
            let found_asset = this.loopAssetsTree(assets, asset_id);
            if (found_asset) {
                found_assets.push(found_asset);
            }
        });
        return found_assets;
    },
    loopAssetsTree(assets, asset_id) {
        for (let i = 0; i < assets.length; i++) {
            if (assets[i] && assets[i].id === asset_id) {
                return assets[i];
            }
            else if (assets[i] && assets[i].children) {
                let found_asset = this.loopAssetsTree(assets[i].children, asset_id);
                if (found_asset) {
                    return found_asset;
                }
            }
        }
    },
    customSearchByID(items, search) {
        this.model_ids_for_search = search;
        this.searchInModelsByID(items);
        let filtered_items = items.filter(function (el) {
            return el != null;
        });
        this.found_model_ids = [];
        this.getModelsAndIDs(filtered_items);
        return [filtered_items,  this.found_model_ids, this.found_models];
    },
    searchInModelsByID(items) {
        let found = false;
        if (items) {
            items.forEach((item, key) => {
                if (item) {
                    if (item.children) {
                        if (this.searchInModelsByID(item.children)) {
                            found = true;
                        }
                        else if (this.model_ids_for_search.includes(item.id)) {
                            found = true;
                        }
                        else {
                            delete items[key];
                        }
                    }
                    else if (this.model_ids_for_search.includes(item.id)) {
                        found = true;
                    }
                    else {
                        delete items[key];
                    }
                }
            });
        }
        return found;
    },
    customSearch(items, search) {
        this.reg_exp = new RegExp(search, "i");
        this.searchInTree(items);
        let filtered_items = items.filter(function (el) {
            return el != null;
        });
        this.found_models = [];
        this.found_model_ids = [];
        this.getModelsAndIDs(filtered_items);
        return [filtered_items, this.found_model_ids, this.found_models];
    },
    searchInTree(items) {
        let found = false;
        if (items) {
            items.forEach((item, key) => {
                if (item) {
                    if (item.children) {
                        if (this.searchInTree(item.children)) {
                            found = true;
                        } else if (item.name && item.name.match(this.reg_exp)) {
                            found = true;
                        } else {
                            delete items[key];
                        }
                    } else if (item.name && item.name.match(this.reg_exp)) {
                        found = true;
                    } else {
                        delete items[key];
                    }
                }
            });
        }
        return found;
    },
    getModelsAndIDs(items) {
        if (items) {
            items.forEach((item) => {
                if (item) {
                    if (item.children) {
                        this.getModelsAndIDs(item.children);
                    }
                    this.found_models.push(item);
                    this.found_model_ids.push(item.id);
                }
            });
        }
    },
    sortByTags(items, tags) {
        this.tags = tags;
        this.found_models = [];
        this.traverseAssetsTags(items);
        let filtered_items = items.filter(function (el) {
            return el != null;
        });
        return [filtered_items, this.found_models];
    },
    traverseAssetsTags(items) {
        let found = false;
        if (items) {
            items.forEach((item, key) => {
                if (item) {
                    if (item.children) {
                        if (this.traverseAssetsTags(item.children)) {
                            found = true;
                        } else if (item.tags.some((tag) => this.tags.includes(tag))) {
                            found = true;
                        } else {
                            delete items[key];
                        }
                    } else if (item.tags.some((tag) => this.tags.includes(tag))) {
                        found = true;
                        this.found_models.push(item);
                    } else {
                        delete items[key];
                    }
                }
            });
        }
        return found;
    },
    customSortingAndFiltering(items) {
        this.sortAndFilterModels(items);
        return items;
    },
    sortAndFilterModels(items) {
        items = items.filter(function (el) {
            return el != null;
        });
        if(items.length === 0) {
            return null;
        }
        else {
            items.forEach((item) => {
                items = lodash.sortBy(items, "name");
                if (item.children && Array.isArray(item.children)) {
                    item.children = this.sortAndFilterModels(item.children);
                }
            });
            return items;
        }
    },
    async getRootAssets(toasted) {
        const response = await axios.post(store.getters.appUrl + "v2/additional-models-full", { model: "asset", root: true })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if (response && response.status === 200) {
            return response.data;
        }

        return false;
    },
    async loadSelectedRootAssets(toasted, selected_root_assets) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/additional-models-full", { model: "asset", selected_root_assets: selected_root_assets })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return lodash.sortBy(response.data, "name");
        }

        return false;
    },
    //NEW ASSET TREE FUNCTIONS
    findItemById(items, id) {
        for (let item of items) {
            if (item.id === id) {
                return item;
            }
            if (item.children) {
                const found = this.findItemById(item.children, id);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    },
    //UNIVERSAL FUNCTIONS
    async getFields(model, action, disabled) {
        await store.dispatch('setLoader', true);
        let additionalModels = {};
        const response = await axios.get(store.getters.appUrl + "v2/fields?" + action + "=true&model_type=" + model);
        let data = response.data;
        let tags_required = false;
        let usual_fields = [];
        let custom_fields = [];
        let promises = [];
        for (let x = 0; x < data.length; x++) {
            if (data[x].custom_field == 1) {
                if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            text: store.getters.translate(data[x].available_options[i]),
                            value: data[x].available_options[i],
                        };
                    }
                }
                custom_fields.push(data[x]);
            }
            else if(data[x].name === 'tags') {
                tags_required = true;
            }
            else if(disabled) {
                data[x].name = data[x].name.replace('_id', '_name');
                if(data[x].field_type === 'select_single') {
                    data[x].field_type = 'text_field';
                }
                usual_fields.push(data[x]);
            }
            else {
                if(data[x].name === 'action_and_decision_id') {
                    if(!additionalModels.action_and_decisions) {
                        additionalModels.action_and_decisions = this.getAdditionalModelsForDropdowns("actionanddecision", "id", ["name"]);
                        promises.push(additionalModels.action_and_decisions);
                    }
                    data[x].available_options = additionalModels.action_and_decisions;
                }
                else if(data[x].name === 'ambient_temperature_id') {
                    if(!additionalModels.ambient_temperatures) {
                        additionalModels.ambient_temperatures = this.getAdditionalModelsForDropdowns("ambienttemperature", "id", ["code", "low", "high"]);
                        promises.push(additionalModels.ambient_temperatures);
                    }
                    data[x].available_options = additionalModels.ambient_temperatures;
                }
                else if(data[x].name === 'application_id') {
                    if(!additionalModels.applications) {
                        additionalModels.applications = this.getAdditionalModelsForDropdowns("application", "id", ["name"]);
                        promises.push(additionalModels.applications);
                    }
                    data[x].available_options = additionalModels.applications;
                }
                else if(data[x].name === 'article_id') {
                    if(!additionalModels.articles) {
                        additionalModels.articles = this.getAdditionalModelsForDropdowns("article", "id", ["id"]);
                        promises.push(additionalModels.articles);
                    }
                    data[x].available_options = additionalModels.articles;
                }
                else if(data[x].name === 'brand_id') {
                    if(!additionalModels.brands) {
                        additionalModels.brands = this.getAdditionalModelsForDropdowns("brand", "id", ["name"]);
                        promises.push(additionalModels.brands);
                    }
                    data[x].available_options = additionalModels.brands;
                }
                else if(data[x].name === 'category_id') {
                    if(!additionalModels.categories) {
                        additionalModels.categories = this.getAdditionalModelsForDropdowns("questioncategory", "id", ["name"]);
                        promises.push(additionalModels.categories);
                    }
                    data[x].available_options = additionalModels.categories;
                }
                else if(data[x].name === 'characteristic_id') {
                    if(!additionalModels.characteristics) {
                        additionalModels.characteristics = this.getAdditionalModelsForDropdowns("characteristic", "id", ["name"]);
                        promises.push(additionalModels.characteristics);
                    }
                    data[x].available_options = additionalModels.characteristics;
                }
                else if(data[x].name === 'classification_id' || data[x].name === 'classification_ids') {
                    if(!additionalModels.classifications) {
                        additionalModels.classifications = this.getAdditionalModelsForDropdowns("classification", "id", ["code", "description"]);
                        promises.push(additionalModels.classifications);
                    }
                    data[x].available_options = additionalModels.classifications;
                }
                else if(data[x].name === 'conformity_mark_id') {
                    if(!additionalModels.conformity_marks) {
                        additionalModels.conformity_marks = this.getAdditionalModelsForDropdowns("conformitymark", "id", ["name"]);
                        promises.push(additionalModels.conformity_marks);
                    }
                    data[x].available_options = additionalModels.conformity_marks;
                }
                else if(data[x].name === 'country_of_birth_id') {
                    if(!additionalModels.countries) {
                        additionalModels.countries = this.getAdditionalModelsForDropdowns("country", "country_id", ["country_name"]);
                        promises.push(additionalModels.countries);
                    }
                    data[x].available_options = additionalModels.countries;
                }
                else if(data[x].name === 'defect_id') {
                    if(!additionalModels.defects) {
                        additionalModels.defects = this.getAdditionalModelsForDropdowns("defect", "id", ["description_en"]);
                        promises.push(additionalModels.defects);
                    }
                    data[x].available_options = additionalModels.defects;
                }
                else if(data[x].name === 'distribution_device_function_id') {
                    if(!additionalModels.distribution_device_functions) {
                        additionalModels.distribution_device_functions = this.getAdditionalModelsForDropdowns("distributiondevicefunction", "id", ["name"]);
                        promises.push(additionalModels.distribution_device_functions);
                    }
                    data[x].available_options = additionalModels.distribution_device_functions;
                }
                else if(data[x].name === 'distribution_panel_id') {
                    if(!additionalModels.distribution_panels) {
                        additionalModels.distribution_panels = this.getAdditionalModelsForDropdowns("distributionpanel", "id", ["name"]);
                        promises.push(additionalModels.distribution_panels);
                    }
                    data[x].available_options = additionalModels.distribution_panels;
                }
                else if(data[x].name === 'equipment_category_id') {
                    if(!additionalModels.equipment_categories) {
                        additionalModels.equipment_categories = this.getAdditionalModelsForDropdowns("equipmentcategory", "id", ["name"]);
                        promises.push(additionalModels.equipment_categories);
                    }
                    data[x].available_options = additionalModels.equipment_categories;
                }
                else if(data[x].name === 'equipment_group_id') {
                    if(!additionalModels.equipment_groups) {
                        additionalModels.equipment_groups = this.getAdditionalModelsForDropdowns("equipmentgroup", "id", ["name", "description"]);
                        promises.push(additionalModels.equipment_groups);
                    }
                    data[x].available_options = additionalModels.equipment_groups;
                }
                else if(data[x].name === 'equipment_protection_level_id' || data[x].name === 'equipment_protection_level_ids') {
                    if(!additionalModels.equipment_protection_levels) {
                        //description is commented for now due to Greg`s notes
                        additionalModels.equipment_protection_levels = this.getAdditionalModelsForDropdowns("equipmentprotectionlevel", "id", ["name", "description"]);
                        //additionalModels.equipment_protection_levels = this.getAdditionalModelsForDropdowns("equipmentprotectionlevel", "id", ["name"]);
                        promises.push(additionalModels.equipment_protection_levels);
                    }
                    data[x].available_options = additionalModels.equipment_protection_levels;
                }
                else if(data[x].name === 'equipment_type_id') {
                    if(!additionalModels.equipment_types) {
                        additionalModels.equipment_types = this.getAdditionalModelsForDropdowns("equipmenttype", "id", ["name"]);
                        promises.push(additionalModels.equipment_types);
                    }
                    data[x].available_options = additionalModels.equipment_types;
                }
                else if(data[x].name === 'explosive_atmosphere_id') {
                    if(!additionalModels.explosive_atmospheres) {
                        additionalModels.explosive_atmospheres = this.getAdditionalModelsForDropdowns("explosiveatmosphere", "id", ["name", "description"]);
                        promises.push(additionalModels.explosive_atmospheres);
                    }
                    data[x].available_options = additionalModels.explosive_atmospheres;
                }
                else if(data[x].name === 'gas_group_id' || data[x].name === 'gas_group_ids') {
                    if(!additionalModels.gas_groups) {
                        //description is commented for now due to Greg`s notes
                        additionalModels.gas_groups = this.getAdditionalModelsForDropdowns("gasgroup", "id", ["name", "description"]);
                        //additionalModels.gas_groups = this.getAdditionalModelsForDropdowns("gasgroup", "id", ["name"]);
                        promises.push(additionalModels.gas_groups);
                    }
                    data[x].available_options = additionalModels.gas_groups;
                }
                else if(data[x].name === 'inspection_certificate_id') {
                    if(!additionalModels.inspection_certificates) {
                        additionalModels.inspection_certificates = this.getAdditionalModelsForDropdowns("inspectioncertificate", "id", ["full_name"]);
                        promises.push(additionalModels.inspection_certificates);
                    }
                    data[x].available_options = additionalModels.inspection_certificates;
                }
                else if(data[x].name === 'inspection_code_id') {
                    if(!additionalModels.inspection_codes) {
                        //description is commented for now due to Greg`s notes
                        //additionalModels.inspection_codes = this.getAdditionalModelsForDropdowns("inspectioncode", "id", ["code", "description"]);
                        additionalModels.inspection_codes = this.getAdditionalModelsForDropdowns("inspectioncode", "id", ["code"]);
                        promises.push(additionalModels.inspection_codes);
                    }
                    data[x].available_options = additionalModels.inspection_codes;
                }
                else if(data[x].name === 'inspection_institute_certification_id') {
                    if(!additionalModels.inspection_institute_certifications) {
                        additionalModels.inspection_institute_certifications = this.getAdditionalModelsForDropdowns("inspectioninstitutecertification", "id", ["name"]);
                        promises.push(additionalModels.inspection_institute_certifications);
                    }
                    data[x].available_options = additionalModels.inspection_institute_certifications;
                }
                else if(data[x].name === 'inspection_institute_id') {
                    if(!additionalModels.inspection_institutes) {
                        additionalModels.inspection_institutes = this.getAdditionalModelsForDropdowns("inspectioninstitute", "id", ["full_name"]);
                        promises.push(additionalModels.inspection_institutes);
                    }
                    data[x].available_options = additionalModels.inspection_institutes;
                }
                else if(data[x].name === 'inspection_id') {
                    if(!additionalModels.inspections) {
                        additionalModels.inspections = this.getAdditionalModelsForDropdowns("inspection", "id", ["project_number"]);
                        promises.push(additionalModels.inspections);
                    }
                    data[x].available_options = additionalModels.inspections;
                }
                else if(data[x].name === 'ip_indication_id' || data[x].name === 'ip_indication_t_m_id') {
                    if(!additionalModels.ip_indications) {
                        additionalModels.ip_indications = this.getAdditionalModelsForDropdowns("ipindication", "id", ["name", "description"]);
                        promises.push(additionalModels.ip_indications);
                    }
                    data[x].available_options = additionalModels.ip_indications;
                }
                else if(data[x].name === 'ip_type_id' || data[x].name === 'ip_type_t_m_id' || data[x].name === 'ip_type_ids') {
                    if(!additionalModels.ip_types) {
                        //description is commented for now due to Greg`s notes
                        //additionalModels.ip_types = this.getAdditionalModelsForDropdowns("iptype", "id", ["name", "description"]);
                        additionalModels.ip_types = this.getAdditionalModelsForDropdowns("iptype", "id", ["name"]);
                        promises.push(additionalModels.ip_types);
                    }
                    data[x].available_options = additionalModels.ip_types;
                }
                else if(data[x].name === 'line_voltage_id') {
                    if(!additionalModels.line_voltage) {
                        additionalModels.line_voltage = this.getAdditionalModelsForDropdowns("linevoltage", "id", ["voltage", "ac_dc"], " ");
                        promises.push(additionalModels.line_voltage);
                    }
                    data[x].available_options = additionalModels.line_voltage;
                }
                else if(data[x].name === 'location_id') {
                    if(!additionalModels.locations) {
                        additionalModels.locations = this.getAdditionalModelsForDropdowns("location", "id", ["name"]);
                        promises.push(additionalModels.locations);
                    }
                    data[x].available_options = additionalModels.locations;
                }
                else if(data[x].name === 'markering_id') {
                    if(!additionalModels.markering) {
                        additionalModels.markering = this.getAdditionalModelsForDropdowns("markering", "id", ["name"]);
                        promises.push(additionalModels.markering);
                    }
                    data[x].available_options = additionalModels.markering;
                }
                else if(data[x].name === 'nationality_id') {
                    if(!additionalModels.nationalities) {
                        additionalModels.nationalities = this.getAdditionalModelsForDropdowns("nationality", "nationality_id", ["nationality_name"]);
                        promises.push(additionalModels.nationalities);
                    }
                    data[x].available_options = additionalModels.nationalities;
                }
                else if(data[x].name === 'project_id') {
                    if(!additionalModels.projects) {
                        additionalModels.projects = this.getAdditionalModelsForDropdowns("project", "id", ["name"], " | ", "closed");
                        promises.push(additionalModels.projects);
                    }
                    data[x].available_options = additionalModels.projects;
                }
                else if(data[x].name === 'project_management_id') {
                    if(!additionalModels.project_management) {
                        additionalModels.project_management = this.getAdditionalModelsForDropdowns("projectmanagement", "id", ["name"]);
                        promises.push(additionalModels.project_management);
                    }
                    data[x].available_options = additionalModels.project_management;
                }
                else if(data[x].name === 'protection_kind_id') {
                    if(!additionalModels.protection_kinds) {
                        additionalModels.protection_kinds = this.getAdditionalModelsForDropdowns("protectionkind", "id", ["name"]);
                        promises.push(additionalModels.protection_kinds);
                    }
                    data[x].available_options = additionalModels.protection_kinds;
                }
                else if(data[x].name === 'protection_method_id') {
                    if(!additionalModels.protection_methods) {
                        additionalModels.protection_methods = this.getAdditionalModelsForDropdowns("protectionmethod", "id", ["code", "description"]);
                        promises.push(additionalModels.protection_methods);
                    }
                    data[x].available_options = additionalModels.protection_methods;
                }
                else if(data[x].name === 'protection_type_id') {
                    if(!additionalModels.protection_types) {
                        additionalModels.protection_types = this.getAdditionalModelsForDropdowns("protectiontype", "id", ["type"]);
                        promises.push(additionalModels.protection_types);
                    }
                    data[x].available_options = additionalModels.protection_types;
                }
                else if(data[x].name === 'punchlist_id') {
                    if(!additionalModels.punchlists) {
                        additionalModels.punchlists = this.getAdditionalModelsForDropdowns("punchlist", "id", ["name"]);
                        promises.push(additionalModels.punchlists);
                    }
                    data[x].available_options = additionalModels.punchlists;
                }
                else if(data[x].name === 'procedure_id') {
                    if(!additionalModels.procedures) {
                        additionalModels.procedures = this.getAdditionalModelsForDropdowns("procedure", "id", ["name"]);
                        promises.push(additionalModels.procedures);
                    }
                    data[x].available_options = additionalModels.procedures;
                }
                else if(data[x].name === 'questionnaire_id') {
                    if(!additionalModels.questionnaires) {
                        additionalModels.questionnaires = this.getAdditionalModelsForDropdowns("questionnaire", "id", ["name"]);
                        promises.push(additionalModels.questionnaires);
                    }
                    data[x].available_options = additionalModels.questionnaires;
                }
                else if(data[x].name === 'regulation_id') {
                    if(!additionalModels.regulations) {
                        additionalModels.regulations = this.getAdditionalModelsForDropdowns("regulation", "id", ["name", "description"]);
                        promises.push(additionalModels.regulations);
                    }
                    data[x].available_options = additionalModels.regulations;
                }
                else if(data[x].name === 'room_id') {
                    if(!additionalModels.rooms) {
                        additionalModels.rooms = this.getAdditionalModelsForDropdowns("room", "id", ["name"]);
                        promises.push(additionalModels.rooms);
                    }
                    data[x].available_options = additionalModels.rooms;
                }
                else if(data[x].name === 'root_asset_id' || data[x].name === 'second_root_asset_id' || data[x].name === 'third_root_asset_id' || data[x].name === 'fourth_root_asset_id' || data[x].name === 'fifth_root_asset_id') {
                    if(!additionalModels.root_assets) {
                        additionalModels.root_assets = this.getAdditionalModelsForDropdowns("asset", "id", ["name"]);
                        promises.push(additionalModels.root_assets);
                    }
                    data[x].available_options = additionalModels.root_assets;
                }
                else if(data[x].name === 'tag_number_id') {
                    if(!additionalModels.tag_numbers) {
                        additionalModels.tag_numbers = this.getAdditionalModelsForDropdowns("tagnumber", "id", ["name"], " | ", "root_asset_id");
                        promises.push(additionalModels.tag_numbers);
                    }
                    data[x].available_options = additionalModels.tag_numbers;
                }
                else if(data[x].name === 'temperature_class_id') {
                    if(!additionalModels.temperature_classes) {
                        //description is commented for now due to Greg`s notes
                        additionalModels.temperature_classes = this.getAdditionalModelsForDropdowns("temperatureclass", "id", ["name", "maximum_surface_temperature"]);
                        //additionalModels.temperature_classes = this.getAdditionalModelsForDropdowns("temperatureclass", "id", ["name"]);
                        promises.push(additionalModels.temperature_classes);
                    }
                    data[x].available_options = additionalModels.temperature_classes;
                }
                else if(data[x].name === 'user_id' || data[x].name === 'delegate_id') {
                    if(!additionalModels.users) {
                        additionalModels.users = this.getAdditionalModelsForDropdowns("user", "id", ["name"]);
                        promises.push(additionalModels.users);
                    }
                    data[x].available_options = additionalModels.users;
                }
                else if(data[x].name === 'owner_id' || data[x].name === 'punched_by' || data[x].name === 'follow_up_by' || data[x].name === 'technical_authority_by' ||
                        data[x].name === 'executor_id' ||data[x].name === 'head_project_executor_id' || data[x].name === 'project_executor_id' ||
                        data[x].name === 'initial_inspector_id' || data[x].name === 'after_remedial_inspector_id' || data[x].name === 'project_engineer_id' ||
                        data[x].name === 'discipline_engineer_ids' || data[x].name === 'construction_responsible_id' || data[x].name === 'commissioning_responsible_id' ||
                        data[x].name === 'employee_ids' || data[x].name === 'employee_id' || data[x].name === 'accepted_by_id' || data[x].name === 'assigned_to_id' ||
                        data[x].name === 'responsible_employee_id') {
                    if(!additionalModels.employees) {
                        additionalModels.employees = this.getAdditionalModelsForDropdowns("employee", "id", ["name"]);
                        promises.push(additionalModels.employees);
                    }
                    data[x].available_options = additionalModels.employees;
                }
                //CUSTOM FIX FOR TYPES AND SUBTYPES IN DOCUMENTS AND FORMS
                else if(data[x].name === 'subtype' && (model === "document" || model === "form")) {
                    if(!additionalModels.subtypes) {
                        additionalModels.subtypes = this.getAdditionalModelsForDropdowns("typesandsubtype", "name", ["name"], " | ", "subtype");
                        promises.push(additionalModels.subtypes);
                    }
                    data[x].available_options = additionalModels.subtypes;
                }
                else if(data[x].name === 'type' && (model === "document" || model === "form")) {
                    if(!additionalModels.types) {
                        additionalModels.types = this.getAdditionalModelsForDropdowns("typesandsubtype", "name", ["name"], " | ", "type");
                        promises.push(additionalModels.types);
                    }
                    data[x].available_options = additionalModels.types;
                }
                else if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            value: data[x].available_options[i],
                            text: store.getters.translate(data[x].available_options[i]),
                        };
                    }
                }
                usual_fields.push(data[x]);
            }
        }
        await Promise.all(promises);
        for (let x = 0; x < data.length; x++) {
            if (data[x].available_options && typeof data[x].available_options.then === 'function') {
                data[x].available_options = await data[x].available_options;
            }
        }
        await store.dispatch('setLoader', false);
        return { tags_required: tags_required, usual_fields: usual_fields, custom_fields: custom_fields };
    },
    composeFields(fields, add_actions_column) {
        let response = [];
        let field_names = Object.keys(fields);
        for (let i = 0; i < field_names.length; i++) {
            if(store.getters.getUser.superuser || (field_names[i] !== 'mandatory' && field_names[i] !== 'show_on_creation' && field_names[i] !== 'show_on_update')) {
                const field = {
                    title: store.getters.translate(field_names[i]),
                    key: field_names[i],
                    align: "start",
                    fixed: true,
                    sortable: true,
                    value: field_names[i],
                };
                if (fields[field_names[i]] === 'date') {
                    field.sort = (a, b) => {
                        let dateA;
                        let dateB;
                        if(field_names[i] === 'created_at' || field_names[i] === 'updated_at' || field_names[i] === 'last_used_at') {
                            dateA = a ? moment(a).toDate() : null;
                            dateB = b ? moment(b).toDate() : null;
                        }
                        else {
                            dateA = a ? moment(a, 'DD-MM-YYYY', true).toDate() : null;
                            dateB = b ? moment(b, 'DD-MM-YYYY', true).toDate() : null;
                        }

                        // Fall back to new Date if Moment parsing fails
                        // No need to do it because we have only 2 cases:
                        // timestamp for created_at/updated_at and DD-MM-YYYY for everything else
                        /*if (dateA && isNaN(dateA.getTime())) {
                            dateA = a ? new Date(a) : null;
                        }
                        if (dateB && isNaN(dateB.getTime())) {
                            dateB = b ? new Date(b) : null;
                        }*/

                        if (!dateA || isNaN(dateA.getTime())) {
                            if (!dateB || isNaN(dateB.getTime())) {
                                return 0;
                            } else {
                                return -1;
                            }
                        } else if (!dateB || isNaN(dateB.getTime())) {
                            return 1;
                        } else {
                            return dateA.getTime() - dateB.getTime();
                        }
                    }
                }

                response.push(field);
            }
        }
        if (add_actions_column) {
            response.push({
                title: '',
                align: 'center',
                fixed: true,
                sortable: false,
                value: 'actions',
                width: '80px',
            });
        }
        return response;
    },
    async getAdditionalModelsForDropdowns(model, option_id, option_name, separator = " | ", filter) {
        let models = [];
        const response = await axios.post(store.getters.appUrl + "v2/additional-models-for-dropdowns", { model: model, fields: option_name.join(), filter: filter });
        let data = response.data.data ? response.data.data : response.data;
        data.forEach((option) => {
            let text = [];
            for (let i = 0; i < option_name.length; i++) {
                if(option[option_name[i]]) {
                    text.push(store.getters.translate(option[option_name[i]]));
                }
            }
            let record = { value: option[option_id], text: text.join(separator) };
            if(filter) {
                record.filter = option[filter];
            }
            models.push(record);
        });
        return lodash.sortBy(models, "text");
    },
    async getOneFullAdditionalModel(toasted, model, id, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/get-one-additional-model", { model: model, id: id })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return {};
        }
    },
    async getFullAdditionalModels(toasted, model, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/additional-models-full", { model: model })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async getModelsForTables(toasted, model) {
        await store.dispatch('setLoader', true);
        const response = await axios.get(store.getters.appUrl + "v2/" + model + "?source=site")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async loadModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.get(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            let result = response.data;
            let modelsWithCustomFields = ["articles", "companies", "contacts", "defects", "documents", "employees", "inspections", "projects", "tagnumbers"];

            if (modelsWithCustomFields.includes(model)) {
                if (result.custom_fields == null || Array.isArray(result.custom_fields) || typeof result.custom_fields !== "object") {
                    result.custom_fields = {};
                }
            }
            return result;
        }
        return false;
    },
    async createModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data.id;
        }

        return false;
    },
    async createModelSilently(model, record) {
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record);
        return response && response.status === 200;
    },
    async saveModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    async saveModelSilently(model, record) {
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record);
        return response && response.status === 200;
    },
    async deleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async restoreModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/" + model_id + "/restore")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_restored"));
            return true;
        }

        return false;
    },
    async forceDeleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id + "/delete")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async getPDFFile(toasted, url, params) {
        await store.dispatch('setLoader', true);

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    async getFile(toasted, id) {
        await store.dispatch('setLoader', true);

        const response = await axios.get(store.getters.appUrl + "v2/files/" + id, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    async saveFile(toasted, model, formData) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/uploadfiles", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data;
        }
    },
    async deleteFile(toasted, model, params) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/deletefiles", params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            })

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }
    },
    async getCustomRoute(toasted, url, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.get(store.getters.appUrl + "v2/" + url)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }

        return false;
    },
    async postCustomRoute(toasted, url, params, show_success = false, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            if(show_success) {
                toasted.success(store.getters.translate("success"));
            }
            return response.data;
        }

        return false;
    },
    async patchCustomRoute(toasted, url, params, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.patch(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    modelFieldsFilled(toasted, record, fields, ignore_fields = []) {
        let status = true;
        for (let i = 0; i < fields.length; i++) {
            if ((fields[i].name === 'first_name' || fields[i].name === 'last_name') && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate('name'));
                status = false;
            }
            else if (fields[i].mandatory && !ignore_fields.includes(fields[i].name) && fields[i].field_type !== 'boolean' && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate(fields[i].name));
                status = false;
            }
        }
        return status;
    },
    getCorrectPage(field_name) {
        if(field_name === 'application_id') {
            return { page: this.pages.applications, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'brand_id') {
            return { page: this.pages.brands, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'classification_ids') {
            return { page: this.pages.classifications, modal_type: "create_new_record_trans", files_required: false, multiple_files: false };
        }
        else if(field_name === 'distribution_panel_id') {
            return { page: this.pages.distributionpanels, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'distribution_device_function_id') {
            return { page: this.pages.distributiondevicefunctions, modal_type: "create_new_record_trans", files_required: false, multiple_files: false };
        }
        else if(field_name === 'equipment_type_id') {
            return { page: this.pages.equipmenttypes, modal_type: "create_new_record_trans", files_required: false, multiple_files: false };
        }
        else if(field_name === 'gas_group_id') {
            return { page: this.pages.gasgroups, modal_type: "create_new_record_trans", files_required: false, multiple_files: false };
        }
        else if(field_name === 'inspection_institute_id') {
            return { page: this.pages.inspectioninstitutes, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'inspection_institute_certification_id') {
            return { page: this.pages.inspectioninstitutecertifications, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'inspection_certificate_id') {
            return { page: this.pages.inspectioncertificates, modal_type: "create_new_record", files_required: true, multiple_files: true };
        }
        else if(field_name === 'inspection_code_id') {
            return { page: this.pages.inspectioncodes, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'ip_indication_id' || field_name === 'ip_indication_t_m_id') {
            return { page: this.pages.ipindications, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'ip_type_id' || field_name === 'ip_type_t_m_id' || field_name === 'ip_type_ids') {
            return { page: this.pages.iptypes, modal_type: "create_new_record_trans", files_required: false, multiple_files: false };
        }
        else if(field_name === 'line_voltage_id') {
            return { page: this.pages.linevoltage, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'location_id') {
            return { page: this.pages.locations, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'markering_id') {
            return { page: this.pages.markering, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'room_id') {
            return { page: this.pages.rooms, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'tag_number_id') {
            return { page: this.pages.tagnumbers, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
        else if(field_name === 'temperature_class_id') {
            return { page: this.pages.temperatureclasses, modal_type: "create_new_record", files_required: false, multiple_files: false };
        }
    },
    replaceIDwithNameBaseTable(fields) {
        let new_fields = {};
        for (const key of Object.keys(fields)) {
            if(key !== 'auditable_id' && key !== 'internal_id' && key !== 'country_of_birth_id' && key !== 'nationality_id' && key !== 'classification_ids' && key !== 'discipline_engineer_ids' && key !== 'employee_ids') {
                new_fields[key.replace('_id', '_name').replace('_by', '_by_name')] = fields[key];
            }
            else if(key === 'discipline_engineer_ids' || key === 'employee_ids') {
                new_fields[key.replace('_ids', '_names')] = fields[key];
            }
            else {
                new_fields[key] = fields[key];
            }
        }
        return new_fields;
    },
    replaceIDwithNameBaseTableInc(name) {
        if(name !== 'auditable_id' && name !== 'internal_id' && name !== 'country_of_birth_id' && name !== 'nationality_id' && name !== 'classification_ids') {
            name = name.replace('_ids', '_names').replace('_id', '_name').replace('_by', '_by_name');
        }
        return name;
    },
    removeClosedField(fields) {
        let new_fields = {};
        for (const key of Object.keys(fields)) {
            if(key !== 'closed') {
                new_fields[key] = fields[key];
            }
        }
        return new_fields;
    },
    removeFieldsetTypeField(fields) {
        let new_fields = {};
        for (const key of Object.keys(fields)) {
            if(key !== 'fieldset_type') {
                new_fields[key] = fields[key];
            }
        }
        return new_fields;
    },
    replaceLastChar(model) {
        if(model === 'climate' || model === 'linevoltage' || model === 'markering' || model === 'stof' || model === 'usagefrequency' ||
            model === 'water' || model === 'platformmanagement' || model === 'projectmanagement') {
            return model;
        }
        else if(model === 'company') {
            return 'companies';
        }
        else if(model === 'emergency') {
            return 'emergencies';
        }
        else if(model === 'equipmentcategory') {
            return 'equipmentcategories';
        }
        else if(model === 'inspectionclass') {
            return 'inspectionclasses';
        }
        else if(model === 'temperatureclass') {
            return 'temperatureclasses';
        }
        else if(model === 'questioncategory') {
            return 'questioncategories';
        }
        else {
            return model + "s";
        }
    },
    getLocalStorageValue(value_name) {
        if (localStorage.getItem(value_name)) {
            return JSON.parse(localStorage.getItem(value_name));
        }
        return null;
    },
    setLocalStorageValue(value_name, value) {
        localStorage.setItem(value_name, JSON.stringify(value));
    },
    getBreadcrumbs(module_name, current = null) {
        let response = [{
            title: "Home",
            disabled: false
        }];
        if(module_name !== "dashboard") {
            response[0].to = "/";
            response[1] = {
                title: store.getters.translate(module_name)
            }
            if(current == null) {
                response[1].disabled = true;
            }
            else {
                response[1].disabled = false;
                response[1].href = "/" + module_name;
                response[2] = {
                    title: current,
                    disabled: true
                }
            }
        }
        return response;
    },
    uid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
}

export default helpFunctions